import AppDownload from 'pages/app-download'
import NewsFeedPage from 'pages/news-feed'
import NotFound from 'pages/not-found'
import NotificationDetailPage from 'pages/notification-detail'
import Policies from 'pages/policies'
import SessionExpiredOtpVerify from 'pages/session-expried/session-expried-otp-verify'
import SessionExpiredVerifyEmail from 'pages/session-expried/session-exriped-verify-email'
import { RouteObject } from 'types'

import DefaultLayout from 'components/templates/DefaultLayout'
import EmptyLayout from 'components/templates/EmptyLayout'

const publicRoutes: RouteObject = {
  name: 'public-routes',
  path: '',
  layout: DefaultLayout,
  children: [
    {
      name: 'app-download',
      path: '/app',
      element: <AppDownload />
    },
    {
      name: 'policies',
      path: '/policies',
      element: <Policies />
    },
    {
      name: 'not-found',
      path: '/*',
      element: <NotFound />
    },
    {
      name: 'notification-detail',
      path: 'notifications/:id',
      layout: EmptyLayout,
      element: <NotificationDetailPage />
    },
    {
      name: 'news',
      path: 'news',
      layout: EmptyLayout,
      element: <NewsFeedPage />
    },
    {
      name: 'session-expired-verify-email',
      path: 'session-expired-verify-email',
      element: <SessionExpiredVerifyEmail />,
      meta: {
        skipAuthCheck: true
      }
    },
    {
      name: 'session-expired-otp-verify',
      path: 'session-expired-otp-verify',
      element: <SessionExpiredOtpVerify />,
      meta: {
        skipAuthCheck: true
      }
    }
  ]
}

export default publicRoutes
